export const addressTypes: any = {
  MSISDN: "MSISDN",
  ALPHA_TAG: "Alpha Tag",
  ALPHATAG: "Alpha Tag",
  SMARTGROUP: "SmartGroup",
  SMART_GROUP: "SmartGroup",
  CONTACTGROUP: "ContactGroup",
  CONTACT_GROUP: "ContactGroup",
  CONTACTFILTER: "FilterGroup",
  CONTACT_FILTER: "FilterGroup",
  MOBILE: "Mobile",
  EMAIL: "Email",
  SMS: "SMS",
  IM: "IM",
  INTERNATIONAL_SMS: "International SMS",
  PAGER: "Pager",
  SMARTADDRESS: "Responder Id",
  SMART: "Smart",
  SMART_ADDRESS: "Responder Id",
  PAGER2WAY: "2-Way Pager",
  PAGERTWOWAY: "PAGER2WAY",
  NONE: "None",
  ALTERNATENUMBER2: "Alternate Number 2",
  ALTERNATENUMBER1: "Alternate Number 1",
  ALTERNATENUMBER: "Alternate Number",
  RESPONDERID: "Responder Id",
  RESPONDER: "Responder",
  DIVERTPROFILE: "Divert Profile",
  SHORTCODE: "Short Code",
  ALL: "All",
  TTS: "TTS",
  BULK: "Bulk",
  GROUP: "Group",
  CAMPAIGN_SUBSCRIBER_GROUP: "Campaign",
  ACCOUNT: "Account",
};

export const destinationType = {
  SMS: "SMS",
  INTERNATIONAL_SMS: "INTERNATIONAL_SMS",
  EMAIL: "EMAIL",
  SMART_GROUP: "SMART_GROUP",
  SMARTGROUP: "SMARTGROUP",
  PAGER: "PAGER",
  PAGER2WAY: "PAGER2WAY",
  PAGERTWOWAY: "PAGERTWOWAY",
  IM: "IM",
  CONTACT_FILTER: "CONTACT_FILTER",
  CONTACT_GROUP: "CONTACT_GROUP",
  BULK: "BULK",
  NONE: "NONE",
  GROUP: "GROUP",
  ALL: "ALL",
};

export const TypeToIconMapping = {
  [destinationType.SMS]: "DevicePhoneMobileIcon",
  [destinationType.INTERNATIONAL_SMS]: "DevicePhoneMobileIcon",
  [destinationType.EMAIL]: "EnvelopeIcon",
  [destinationType.SMART_GROUP]: "UserGroupIcon",
  [destinationType.SMARTGROUP]: "UserGroupIcon",
  [destinationType.PAGER]: "BaseSvgIcon",
  [destinationType.PAGER2WAY]: "BaseSvgIcon",
  [destinationType.PAGERTWOWAY]: "BaseSvgIcon",
  [destinationType.IM]: "ChatBubbleLeftEllipsisIcon",
  [destinationType.CONTACT_FILTER]: "UsersIcon",
  [destinationType.CONTACT_GROUP]: "UsersIcon",
  [destinationType.BULK]: "QueueListIcon",
  [destinationType.GROUP]: "UsersIcon",
  [destinationType.NONE]: "NONE",
  [destinationType.ALL]: "NONE",
};

export const getIconName = (type: any) => {
  return (
    TypeToIconMapping[type?.toUpperCase()] ||
    TypeToIconMapping[destinationType.SMS]
  );
};

export const MessagesToContactAddressMapping = {
  [addressTypes.SMS.toUpperCase()]: "mobile",
  [addressTypes.MOBILE.toUpperCase()]: "mobile",
  [addressTypes.TTS.toUpperCase()]: "mobile",
  [addressTypes.PAGER.toUpperCase()]: "pager",
  [addressTypes.PAGERTWOWAY.toUpperCase()]: "pager",
  [addressTypes.RESPONDERID.toUpperCase()]: "responderId",
  [addressTypes.EMAIL.toUpperCase()]: "email",
};

export const getAddressTypeFromMessage = (type: any) => {
  return MessagesToContactAddressMapping[type];
};

export const statsDataSortField = [
  "ALL",
  "SMS",
  "EMAIL",
  "PAGER",
  "GROUP",
  "PAGER2WAY",
  "INTERNATIONAL_SMS",
  "PAGER_SHORT",
  "SMART_GROUP",
  "CONTACT_GROUP",
  "CONTACT_FILTER",
  "SMART",
  "DIVERT",
  "BRIDGE",
  "ROLE",
  "TTS",
  "ACCOUNT",
  "IM",
  "ALTERNATENUMBER1",
  "ALTERNATENUMBER2",
  "RESPONDERID",
  "OTHERS",
  "NONE",
];
export const addAllConstant = "Add all";

export const destinationFields = [
  "mobile",
  "email",
  "im",
  "responderId",
  "pager",
  "fax",
  "alternateNumber1",
  "alternateNumber2",
  "All",
];

export const addressesList = [
  {
    label: "Email",
    value: "email",
  },
  {
    label: "Pager",
    value: "pager",
  },
  {
    label: "Mobile",
    value: "mobile",
  },
  {
    label: "Responder Id",
    value: "responderId",
  },
  {
    label: "IM",
    value: "im",
  },
  {
    label: "Alternate Number 1",
    value: "alternateNumber1",
  },
  {
    label: "Alternate Number 2",
    value: "alternateNumber2",
  },
];

export const getFormatIMAddress = (address: string, addressType: string) => {
  return address &&
    addressType.toUpperCase() == addressTypes.IM &&
    !address.startsWith("@")
    ? `@${address}`
    : address;
};
